import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import flows from "./flows";
import landing from "./landing";
import platformOffers from "./platformOffers";
import signupPlans from "./signupPlans";

export default mergeFragments([base, flows, landing, platformOffers, signupPlans]);
